__turbopack_context__.v({
  "circle": "styles-module__FzG8_W__circle",
  "circleSm": "styles-module__FzG8_W__circleSm",
  "icon": "styles-module__FzG8_W__icon",
  "identifier": "styles-module__FzG8_W__identifier",
  "identifierImg1": "styles-module__FzG8_W__identifierImg1",
  "identifierImg2": "styles-module__FzG8_W__identifierImg2",
  "identifierImg3": "styles-module__FzG8_W__identifierImg3",
  "identifierImg4": "styles-module__FzG8_W__identifierImg4",
  "identifierImg5": "styles-module__FzG8_W__identifierImg5",
  "identifierImg6": "styles-module__FzG8_W__identifierImg6",
  "identifierImgMobile1": "styles-module__FzG8_W__identifierImgMobile1",
  "identifierImgMobile2": "styles-module__FzG8_W__identifierImgMobile2",
  "identifierImgMobile3": "styles-module__FzG8_W__identifierImgMobile3",
  "identifierImgMobile4": "styles-module__FzG8_W__identifierImgMobile4",
  "identifierImgMobile5": "styles-module__FzG8_W__identifierImgMobile5",
  "identifierImgMobile6": "styles-module__FzG8_W__identifierImgMobile6",
  "questionItem": "styles-module__FzG8_W__questionItem",
  "questionItemDesc": "styles-module__FzG8_W__questionItemDesc",
  "questionItemDescOpacity": "styles-module__FzG8_W__questionItemDescOpacity",
  "questionItemTitle": "styles-module__FzG8_W__questionItemTitle",
  "questionsContainer": "styles-module__FzG8_W__questionsContainer",
  "title": "styles-module__FzG8_W__title",
  "toolContainer": "styles-module__FzG8_W__toolContainer",
  "toolContent": "styles-module__FzG8_W__toolContent",
  "toolIcon": "styles-module__FzG8_W__toolIcon",
  "toolList": "styles-module__FzG8_W__toolList",
  "toolLogo": "styles-module__FzG8_W__toolLogo",
  "unset": "styles-module__FzG8_W__unset",
});
